module.exports = __webpack_public_path__ + "static/media/jhenny.38037ff8.jpeg";